export default "__VITE_ASSET__DeI3NZks__"